module.exports = san.defineComponent({
    template: require('../views/trafficAccidentDisablelity.html'),
    initData: function () {
        return {
            showFlag: 1,
            switchFlag: 1,
            caseList: [],
            caseType: 1,
            businessType: 1,
            seen: false,//是否显示伤残等级选择框
            explain: 0,//0:都不显示;1:伤残等级说明;2:受诉法院所在地;3:起诉年份
            max: 6, //伤残最大数
            levels: [], //总伤残等级
            gradeMessage: ["伤残等级（可多选）"], //总伤残信息
            provs: [
                {label: "杭州市", value: "杭州市"},
                {label: "宁波市", value: "宁波市"},
                {label: "温州市", value: "温州市"},
                {label: "金华市", value: "金华市"},
                {label: "台州市", value: "台州市"},
                {label: "嘉兴市", value: "嘉兴市"},
                {label: "湖州市", value: "湖州市"},
                {label: "绍兴市", value: "绍兴市"},
                {label: "衢州市", value: "衢州市"},
                {label: "丽水市", value: "丽水市"},
                {label: "舟山市", value: "舟山市"}
            ],
            selectProv: {label: '杭州市', value: '杭州市'},
            itemNumber: 0,//赔偿项目数量
            params: {
                identityType: 1, //户籍类型：1-城镇；2-农村
                specialCountryside: 1, //农村适用城镇的情况：1-是；2-否
                age: 0, //伤者年龄
                birthdate:'',//出生日期
                level: 10, //伤残等级
                relyOnYears: 9,
                accidentStartTime: new Date().getFullYear(), //事故发生时间
                averageWage: 61099, //地方平均年工资（2016年浙江省）
                disposableIncome: 47237, //人均可支配收入（2016年浙江省）
                consumerSpending: 30068, //人均消费性支出（2016年浙江省）
                foodFee:0,//住院伙食补助费
                foodFee2: 0,//住院伙食费（金华）
                inDay: 0, //住院天数
                medical: 0, //医疗费
                nutrition: 0, //营养费
                nutritionDay: 0, //休养天数
                nurse: 0, //护理费
                nurseDay: 0, //护理天数
                salary: 0, //伤者年薪，默认为地方平均年工资（2016年浙江省）
                tardyDay: 0, //误工天数o
                identify: 0, //鉴定费
                traffic: 0, //交通费
                assist: 0, //残疾辅助器具费用
                property: 0, //财产损失
                fixedIncome: '1', //有无固定收入,1：有，2：无
                incomeType: '1',//收入类型
                nursingWorker: '1', //是否为专业护工,1：是，2：否
                nursingFixedIncome: '1', //临时护工有无固定收入
                nurseIncome: 0, //临时护工年收入
                dependents: [], //被扶养人
                insurances: [
                    {
                        checked: true,
                        value: 1,
                        label: "交强险"
                    },
                    {
                        checked: false,
                        value: 2,
                        label: "商业险"
                    }
                ], //驾驶员已购买的保险：1-交强险；2-商业险
                youCar: 1, //对方车型：1-机动车；2-非机动车
                youDuty: 1, //对方责任
                ifVehicle:1,//1:机动车 2:非机动车/行人
                mentalDamage: '0',//是否主张精神损害赔偿 0：否；1：是
                grades: [
                    {
                        grade: "未定残",
                        value: 11,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "一级伤残",
                        value: 1,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "二级伤残",
                        value: 2,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "三级伤残",
                        value: 3,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "四级伤残",
                        value: 4,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "五级伤残",
                        value: 5,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "六级伤残",
                        value: 6,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "七级伤残",
                        value: 7,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "八级伤残",
                        value: 8,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "九级伤残",
                        value: 9,
                        number: 0,
                        ischecked: false
                    },
                    {
                        grade: "十级伤残",
                        value: 10,
                        number: 0,
                        ischecked: false
                    }
                ], //伤残等级
                years: [],
                hospitalCategory: 1
            },
            result: {
                disabilityDamage: 0, //残疾赔偿金
                moralDamage: 0, //精神损害抚慰金
                dependentsDamage: 0, //被扶养人生活费
                medicalDamage: 0, //医疗费
                inpatientFoodDamage: 0, //住院伙食补助费
                tardyDamage: 0, //误工费
                nurseDamage: 0, //护理费
                nurseDependenceDamage: 0, //护理依赖
                nutritionDamage: 0, //营养费
                identifyDamage: 0, //鉴定费
                trafficDamage: 0, //交通费
                assistDamage: 0, //残疾辅助器具费
                propertyDamage: 0, //财产损失
                totalDamage: 0, //合计损失
                insuranceDamage1: 0, //交强险赔偿
                insuranceDamage2: 0, //商业险赔偿+驾驶员赔偿
                insuranceDamage3: 0, //受害方承担
                totalDamage2: 0 //赔偿费用合计
            }
        };
    },
    components: {

    },
    created: function() {
        for(var i = 2016;i <= new Date().getFullYear();i++){
            this.data.push('params.years',i);
        }
    },
    attached: function(){
        var me=this;
        $('#mydatepicker').duDatepicker({format: 'yyyy-mm-dd'}).on('datechanged', function(e){
            // me.selectTime(e.date);
            me.data.set('params.birthdate',e.date);
        }); //初始化日期选择器
        this.getAciidentTime();
    },
    reset: function() {
        this.data.set('selectProv' , {
            label: '杭州市', value: '杭州市'});
        this.data.set('showFlag', 1);
        this.data.set('levels' , []); //总伤残等级
        this.data.set('gradeMessage' , ["伤残等级（可多选）"]); //总伤残信息
        this.data.set('params.identityType' , 1); //户籍类型：1-城镇；2-农村
        this.data.set('params.specialCountryside' , 1); //农村适用城镇的情况：1-是；2-否
        this.data.set('params.age' , 0); //伤者年龄
        this.data.set('params.birthdate' , '');//出生日期
        this.data.set('params.level' , 10); //伤残等级
        this.data.set('params.relyOnYears' , 1);
        this.data.set('params.averageWage' , 61099); //地方平均年工资（2016年浙江省）
        this.data.set('params.accidentStartTime' , new Date().getFullYear()); //事故发生时间
        this.data.set('params.disposableIncome' , 47237); //人均可支配收入（2016年浙江省）
        this.data.set('params.foodFee', 0); //住院伙食补助费
        this.data.set('params.foodFee2', 0); //住院伙食补助费
        this.data.set('params.inDay', 0); //住院天数
        this.data.set('params.medical' , 0); //医疗费
        this.data.set('params.nutrition',0); //营养费
        this.data.set('params.nutritionDay', 0); //休养天数
        this.data.set('params.nurse' , 0); //护理费
        this.data.set('params.nurseDay' , 0); //护理天数
        this.data.set('params.salary' , 0)  ; //伤者年薪，默认为地方平均年工资（2016年浙江省）
        this.data.set('params.tardyDay', 0); //误工天数
        this.data.set('params.identify',0); //鉴定费
        this.data.set('params.traffic',0); //交通费
        this.data.set('params.assist',0); //财产损失
        this.data.set('fixedIncome','1');//有无固定收入,1：有，2：无
        this.data.set('incomeType','1');//收入类型
        this.data.set('nursingWorker','1'); //是否为专业护工,1：是，2：否
        this.data.set('nursingFixedIncome','1'); //临时护工有无固定收入
        this.data.set('nurseIncome', 0);//临时护工年收入
        this.data.set('params.dependents', []); //被扶养人
        this.data.set('params.insurances', [
            {
                checked: true,
                value: 1,
                label: "交强险"
            },
            {
                checked: false,
                value: 2,
                label: "商业险"
            }
        ]); //驾驶员已购买的保险：1-交强险；2-商业险
        this.data.set('params.grades', [
            {
                grade: "未定残",
                value: 11,
                number: 0,
                ischecked: false
            },
            {
                grade: "一级伤残",
                value: 1,
                number: 0,
                ischecked: false
            },
            {
                grade: "二级伤残",
                value: 2,
                number: 0,
                ischecked: false
            },
            {
                grade: "三级伤残",
                value: 3,
                number: 0,
                ischecked: false
            },
            {
                grade: "四级伤残",
                value: 4,
                number: 0,
                ischecked: false
            },
            {
                grade: "五级伤残",
                value: 5,
                number: 0,
                ischecked: false
            },
            {
                grade: "六级伤残",
                value: 6,
                number: 0,
                ischecked: false
            },
            {
                grade: "七级伤残",
                value: 7,
                number: 0,
                ischecked: false
            },
            {
                grade: "八级伤残",
                value: 8,
                number: 0,
                ischecked: false
            },
            {
                grade: "九级伤残",
                value: 9,
                number: 0,
                ischecked: false
            },
            {
                grade: "十级伤残",
                value: 10,
                number: 0,
                ischecked: false
            }
        ]); //伤残等级
        this.data.set('params.youCar', 1); //对方车型：1-机动车；2-非机动车
        this.data.set('params.youDuty', 1); //对方责任
        this.data.set('params.ifVehicle',1);//1-机动车；2-非机动车
        this.data.set('params.mentalDamage','0');//是否主张精神损害赔偿
        this.data.set('result', {
            disabilityDamage: 0, //残疾赔偿金
            moralDamage: 0, //精神损害抚慰金
            dependentsDamage: 0, //被扶养人生活费
            medicalDamage: 0, //医疗费
            inpatientFoodDamage: 0, //住院伙食补助费
            tardyDamage: 0, //误工费
            nurseDamage: 0, //护理费
            nurseDependenceDamage: 0, //护理依赖
            nutritionDamage: 0, //营养费
            identifyDamage: 0, //鉴定费
            trafficDamage: 0, //交通费
            assistDamage: 0, //残疾辅助器具费
            propertyDamage: 0, //财产损失
            totalDamage: 0, //合计损失
            insuranceDamage1: 0, //交强险赔偿
            insuranceDamage2: 0, //商业险赔偿+驾驶员赔偿
            insuranceDamage3: 0, //受害方承担
            totalDamage2: 0 //赔偿费用合计
        });
        this.data.set('params.hospitalCategory', 0); //住院伙食补助费
    },
    changeIdentityType: function(){
        if(this.data.get('params.identityType') == 1){
            this.data.set('params.specialCountryside', 1);
        }
        this.getAciidentTime();
    },
    getAciidentTime: function(){
        //金华市护理费统一为150元/天 19.7.18
        if(this.data.get('selectProv.value') == "金华市"){
            this.data.set('params.nurseIncome', 150);
            this.changeHospital();
        }
        var t = Number(this.data.get('params.accidentStartTime'));
        var v = this.data.get('selectProv.value');
        var me = this;
        this.selectTime();
        if(this.data.get('params.identityType') == 2 && this.data.get('params.specialCountryside') == 2){
            switch (t){
                case 2016:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 57550);
                        me.data.set('params.disposableIncome', 26469);
                        me.data.set('params.consumerSpending', 17800);
                    }else {
                        me.data.set('params.averageWage', 51719);
                        me.data.set('params.disposableIncome', 21125);
                        me.data.set('params.consumerSpending', 16108);
                    }
                    break;
                case 2017:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 61342);
                        me.data.set('params.disposableIncome', 28572);
                        me.data.set('params.consumerSpending', 19313);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 56385);
                        me.data.set('params.disposableIncome', 38529);
                        me.data.set('params.consumerSpending', 17359);
                    }else if (v == "绍兴市") {
                        me.data.set('params.averageWage', 56385);
                        me.data.set('params.disposableIncome', 47237);
                        me.data.set('params.consumerSpending', 30068);
                    }else {
                        me.data.set('params.averageWage', 56385);
                        me.data.set('params.disposableIncome', 22866);
                        me.data.set('params.consumerSpending', 17359);
                    }
                    break;
                case 2018:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 30871);
                        me.data.set('params.consumerSpending', 20239);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 61099);
                        me.data.set('params.disposableIncome', 42046);
                        me.data.set('params.consumerSpending', 18093);
                    }else if (v == "绍兴市") {
                        me.data.set('params.averageWage', 61099);
                        me.data.set('params.disposableIncome', 51261);
                        me.data.set('params.consumerSpending', 31924);
                    }else {
                        me.data.set('params.averageWage', 61099);
                        me.data.set('params.disposableIncome', 24956);
                        me.data.set('params.consumerSpending', 18093);
                    }
                    break;
                case 2019:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 30871);
                        me.data.set('params.consumerSpending', 20239);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 45840);
                        me.data.set('params.consumerSpending', 19707);
                    }else if (v == "绍兴市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 51261);
                        me.data.set('params.consumerSpending', 31924);
                    }else {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 27302);
                        me.data.set('params.consumerSpending', 19707);
                    }
                    break;
                default:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 30871);
                        me.data.set('params.consumerSpending', 20239);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 45840);
                        me.data.set('params.consumerSpending', 19707);
                    }else if (v == "绍兴市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 51261);
                        me.data.set('params.consumerSpending', 31924);
                    }else {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 27302);
                        me.data.set('params.consumerSpending', 19707);
                    }
                    break;
            }
        }else{
            switch (t){
                case 2016:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 57550);
                        me.data.set('params.disposableIncome', 47852);
                        me.data.set('params.consumerSpending', 29645);
                    }else {
                        me.data.set('params.averageWage', 51719);
                        me.data.set('params.disposableIncome', 43714);
                        me.data.set('params.consumerSpending', 28661);
                    }
                    break;
                case 2017:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 61342);
                        me.data.set('params.disposableIncome', 51560);
                        me.data.set('params.consumerSpending', 31584);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 56385);
                        me.data.set('params.disposableIncome', 38529);
                        me.data.set('params.consumerSpending', 30068);
                    }else {
                        me.data.set('params.averageWage', 56385);
                        me.data.set('params.disposableIncome', 47237);
                        me.data.set('params.consumerSpending', 30068);
                    }
                    break;
                case 2018:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 55656);
                        this.data.set('params.consumerSpending', 33197);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 61099);
                        me.data.set('params.disposableIncome', 42046);
                        me.data.set('params.consumerSpending', 31924);
                    }else {
                        me.data.set('params.averageWage', 61099);
                        me.data.set('params.disposableIncome', 51261);
                        me.data.set('params.consumerSpending', 31924);
                    }
                    break;
                case 2019:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 55656);
                        this.data.set('params.consumerSpending', 33197);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 45840);
                        me.data.set('params.consumerSpending', 34598);
                    }else {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 55574);
                        me.data.set('params.consumerSpending', 34598);
                    }
                    break;
                default:
                    if (v == "宁波市") {
                        me.data.set('params.averageWage', 65578);
                        me.data.set('params.disposableIncome', 55656);
                        this.data.set('params.consumerSpending', 33197);
                    }else if (v == "金华市") {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 45840);
                        me.data.set('params.consumerSpending', 34598);
                    }else {
                        me.data.set('params.averageWage', 66432);
                        me.data.set('params.disposableIncome', 55574);
                        me.data.set('params.consumerSpending', 34598);
                    }
                    break;
            }
        }
        // return this.params.averageWage, this.params.disposableIncome, this.params.consumerSpending;
    },
    addDependents: function() {
        if (this.data.get('params.dependents').length > 20) {
            return;
        }
        if(this.data.get('params.dependents').length > 0){
            this.data.push('params.dependents',{age: 0, hasWorkAbility: 1,children:2,fee: 0,id: (this.data.get('params.dependents['+(this.data.get('params.dependents').length - 1)+']').id + 1)});
        }else if(this.data.get('params.dependents').length == 0){
            this.data.push('params.dependents',{age: 0, hasWorkAbility: 1,children:2,fee: 0,id: 1});
        }
    },
    delDependents: function(index) {
        this.data.splice('params.dependents',[index, 1]);
    },
    selectTime: function(){
        if(this.data.get('params.birthdate')){
            this.data.set('params.age',parseInt(this.data.get('params.accidentStartTime')-parseInt(this.data.get('params.birthdate').split("-")[0])));
            if(this.data.get('params.age')<0){
                this.data.set('params.age' , 0);
            }
        }
    },
    count: function() {
        //交通赔偿责任系数
        var driverRes = 1;
        switch(this.data.get('params.youDuty')){
            case "1":driverRes=1;break;
            case "2":
                if(this.data.get('params.ifVehicle') ==1){
                    driverRes=0.7;
                }else{
                    driverRes=0.8;
                }
                break;
            case "3":
                if(this.data.get('params.ifVehicle') ==1){
                    driverRes=0.5;
                }else{
                    driverRes=0.6;
                }
                break;
            case "4":
                if(this.data.get('params.ifVehicle') ==1){
                    driverRes=0.3;
                }else{
                    driverRes=0.4;
                }
                break;
            case "5":
                if(this.data.get('params.ifVehicle') ==1){
                    driverRes=0;
                }else{
                    driverRes=0.1;
                }
                break;
        }
        //总伤残系数
        var coefficient = 0;
        var addCoefficient = 0;
        var maxCoefficient = 0;
        //伤残系数第一优先级
        var main = true;
        for (var v in this.data.get('params.grades')) {
            if(v.length<=2){
                if (this.data.get('params.grades['+ v +']').ischecked == true) {
                    if (main) {
                        if (this.data.get('params.grades['+ v +']').value == 1) {
                            coefficient = 1;
                            maxCoefficient = 1;
                            break;
                        } else {
                            coefficient = (11 - this.data.get('params.grades['+ v +']').value) / 10;
                            maxCoefficient = coefficient;
                            if (this.data.get('params.grades['+ v +']').number > 1) {
                                if (this.data.get('params.grades['+ v +']').value >= 6 && this.data.get('params.grades['+ v +']').value <= 10) {
                                    addCoefficient += 0.02 * (this.data.get('params.grades['+ v +']').number - 1);
                                } else {
                                    addCoefficient += 0.04 * (this.data.get('params.grades['+ v +']').number - 1);
                                }
                            }
                        }
                        main = false;
                        this.data.set('params.level', this.data.get('params.grades['+ v +']').value);
                    } else if (addCoefficient >= 0.1) {
                        addCoefficient = 0.1;
                        break;
                    } else if (this.data.get('params.grades['+ v +']').value >= 6 && this.data.get('params.grades['+ v +']').value <= 10) {
                        addCoefficient += 0.02 * this.data.get('params.grades['+ v +']').number;
                    } else {
                        addCoefficient += 0.04 * this.data.get('params.grades['+ v +']').number;
                    }
                }
            }
        }
        parseFloat((coefficient += addCoefficient));
        //伤残系数最大为1
        if (coefficient > 1) {
            coefficient = 1;
        }
        var years = 20; //年限
        if (this.data.get('params.age') > 60 && this.data.get('params.age') <= 75) {
            years = 20 - (this.data.get('params.age') - 60);
        } else if (this.data.get('params.age') > 75) {
            years = 5;
        }
        //残疾赔偿金 = 当年当地人均可支配收入 * 伤者年限 * 伤残系数
        this.data.set('result.disabilityDamage' , parseFloat(
            (this.data.get('params.disposableIncome') * years * coefficient).toFixed(2)
        ));
        //精神损害抚慰金 =（3000至5000）* 年限 * 伤残系数，目前统一按5000计算，最多不超过5万
        if(this.data.get('params.mentalDamage') == '0'){
            this.data.set('result.moralDamage' , 0 );
        }else if(this.data.get('params.mentalDamage') == '1'){
            this.data.set('result.moralDamage' , parseFloat((50000 * coefficient).toFixed(2)));
        }
        //被扶养人生活费 = 当年当地人均消费性支出 * 被扶养人年限 * 伤残系数
        var yearArr = [];
        var dep = 0;
        var minyear;
        var overId;//待计算完成的扶养人ID
        var ids = [];//已经计算完成的扶养人ID
        var first =true;
        this.data.set('result.dependentsDamage' , 0);
        for (var i = 0; i < this.data.get('params.dependents').length; i++) {
            var item = this.data.get('params.dependents['+i,']');
            var itemYears = 0; //年限
            item.fee = 0;//原计算的扶养费清零
            //未满18岁
            if(0 <= item.age && item.age < 18){
                itemYears = 18 - item.age;
            }else if(item.age >= 60 || item.hasWorkAbility == 0){//无劳动能力
                itemYears = 20;
                if (item.age <= 75 && item.age >= 60) {
                    itemYears = 20 - (item.age - 60);
                } else if (item.age > 75) {
                    itemYears = 5;
                }
            }
            //老人生活费要除以子女个数
            if(item.children <= 0 || item.children == undefined || item.children == ""){
                item.children = 1;
            }
            yearArr.push({year:itemYears,num:item.children,id:item.id,Proportion:1});
        }
        yearArr = yearArr.sort(this.compare("year"));
        for(var y = 0; y < yearArr.length; y++){
            overId = yearArr[y].id;
            if(y === 0){
                minyear = yearArr[y].year;
            }else{
                minyear = yearArr[y].year - yearArr[y-1].year;
            }
            for(var i = y;i< yearArr.length; i++){
                dep += this.data.get('params.consumerSpending') * coefficient / parseFloat(yearArr[i].num);
            }
            //年赔偿总额累计不超过上一年度城镇居民人均消费性支出额或者村居民人均年生活消费支出额
            if(dep > this.data.get('params.consumerSpending')){
                var totalpp = 0;
                var minNum = 0;
                first = true;
                dep = this.data.get('params.consumerSpending');
                for(var p = 0;p < yearArr.length;p++){
                    if(ids.indexOf(yearArr[p].id) === -1){
                        if(first){
                            yearArr[p].Proportion = 1;
                            minNum = yearArr[p].num;
                            first = false;
                            totalpp = 1;
                        }else{
                            var poi = minNum / yearArr[p].num;
                            yearArr[p].Proportion = poi;
                            totalpp += poi;
                        }
                    }
                }
                for(var  f  in this.data.get('params.dependents')){
                    if(f.length<=2){
                        if(ids.indexOf(this.data.get('params.dependents['+f+']').id) === -1){
                            for(var p in yearArr){
                                if(this.data.get('params.dependents['+f+']').id === yearArr[p].id){
                                    this.data.set('params.dependents['+f+']'.fee , parseFloat((this.data.get('params.dependents['+f+'].fee') + yearArr[p].Proportion * dep / totalpp * minyear).toFixed(2)));
                                }
                            }
                        }
                    }
                }
            }else{
                for(var f  in this.data.get('params.dependents')){
                    if(f.length<=2){
                        if(ids.indexOf(this.data.get('params.dependents['+f+']').id) === -1){
                            this.data.set('params.dependents['+f+'].fee', parseFloat((this.data.get('params.dependents['+f+']').fee + this.data.get('params.consumerSpending') * coefficient / this.data.get('params.dependents['+f+']').children * minyear).toFixed(2)));
                        }
                    }
                }
            }
            ids.push(overId);
            this.data.set('result.dependentsDamage', this.data.get('result.dependentsDamage')+ dep * minyear);
            dep = 0;
        }
        this.data.set('result.dependentsDamage' , parseFloat(
            (this.data.get('result.dependentsDamage')).toFixed(2)
        ));
        //医疗费，根据发票报销，自己填
        this.data.set('result.medicalDamage' , parseFloat(
            parseFloat(this.data.get('params.medical')).toFixed(2)
        ));
        //住院伙食补助费 = （30至50）* 住院天数，目前按50算
        if(this.data.get('selectProv.value') == '金华市' && (this.data.get('params.accidentStartTime') == '2018' || this.data.get('params.accidentStartTime') == '2019')){
            this.data.set('result.inpatientFoodDamage' , parseFloat(
                (this.data.get('params.foodFee2') * this.data.get('params.inDay')).toFixed(2)
            ));
        }else {
            this.data.set('result.inpatientFoodDamage' , parseFloat(
                (this.data.get('params.foodFee') * this.data.get('params.inDay')).toFixed(2)
            ));
        }
        //误工费 = 伤者年工资 / 365 * 住院天数
        //金华
        if(this.data.get('params.fixedIncome') == 2 && this.data.get('selectProv.value') == '金华市' && (this.data.get('params.accidentStartTime') == '2018' || this.data.get('params.accidentStartTime')== '2019')){
            this.data.set('result.tardyDamage' , parseFloat(
                (this.data.get('params.disposableIncome') / 365 * this.data.get('params.tardyDay')).toFixed(2)
            ));
        }else if (this.data.get('params.fixedIncome') == 2 && this.data.get('params.incomeType') == 1) {
            this.data.set('result.tardyDamage' , parseFloat(
                (this.data.get('params.averageWage') / 365 * this.data.get('params.tardyDay')).toFixed(2)
            ));
        } else {
            if(this.data.get('params.incomeType') == 1){
                this.data.set('result.tardyDamage', parseFloat(
                    (this.data.get('params.salary') / 365 * this.data.get('params.tardyDay')).toFixed(2)
                )); //伤者有固定年收入
            }else if(this.data.get('params.incomeType') == 2){
                this.data.set('result.tardyDamage', parseFloat(
                    (this.data.get('params.salary') * 12 / 365 * this.data.get('params.tardyDay')).toFixed(2)
                )); //伤者有固定月收入
            }else if(this.data.get('params.incomeType') == 3){
                this.data.set('result.tardyDamage', parseFloat(
                    (this.data.get('params.salary') * this.data.get('params.tardyDay')).toFixed(2)
                )); //伤者有固定日收入
            }
        }
        //护理费 = 日护理费 * 天数
        if (this.data.get('params.nursingWorker') == 2) {
            if (this.data.get('params.nursingFixedIncome') == 2) {
                this.data.set('params.nurse', parseFloat(this.data.get('params.averageWage') / 365).toFixed(2)); //临时护工，无固定收入
            } else {
                this.data.set('params.nurse', parseFloat(this.data.get('params.nurseIncome') / 365).toFixed(2)); //临时护工，有固定收入
            }
        }
        this.data.set('result.nurseDamage', parseFloat(
            (this.data.get('params.nurse') * this.data.get('params.nurseDay')).toFixed(2)
        ));
        //后续护理依赖 = 年平均工资 * 年数，伤残等级为1-6级才有
        this.data.set('result.nurseDependenceDamage' , 0);
        if (this.data.get('params.level') <= 6) {
            if (this.data.get('params.relyOnYears') == 0) {
                this.data.set('result.nurseDependenceDamage' , parseFloat(
                    (this.data.get('params.averageWage') * 5).toFixed(2)
                ));
            } else if (this.data.get('params.relyOnYears') == 1) {
                this.data.set('result.nurseDependenceDamage' , parseFloat(
                    (this.data.get('params.averageWage') * 0.8 * 5).toFixed(2)
                ));
            } else if (this.data.get('params.relyOnYears') == 2){
                this.data.set('result.nurseDependenceDamage', parseFloat(
                    (this.data.get('params.averageWage') * 0.5 * 5).toFixed(2)
                ));
            }
        }
        //营养费 = （30至50）* 住院天数，目前按50算
        this.data.set('result.nutritionDamage', parseFloat(
            (this.data.get('params.nutrition') * this.data.get('params.nutritionDay')).toFixed(2)
        ));
        //鉴定费，自己填
        this.data.set('result.identifyDamage', parseFloat(
            parseFloat(this.data.get('params.identify')).toFixed(2)
        ));
        //交通费，自己填
        this.data.set('result.trafficDamage', parseFloat(
            parseFloat(this.data.get('params.traffic')).toFixed(2)
        ));
        //残疾辅助器具费用，自己填
        this.data.set('result.assistDamage', parseFloat(
            parseFloat(this.data.get('params.assist')).toFixed(2)
        ));
        //财产损失，自己填
        this.data.set('result.propertyDamage', parseFloat(
            parseFloat(this.data.get('params.property')).toFixed(2)
        ));
        //合计损失：以上损失之和
        this.data.set('result.totalDamage',
            parseFloat(this.data.get('result.disabilityDamage') +
            this.data.get('result.moralDamage') +
            this.data.get('result.dependentsDamage') +
            this.data.get('result.medicalDamage') +
            this.data.get('result.inpatientFoodDamage') +
            this.data.get('result.tardyDamage') +
            this.data.get('result.nurseDamage') +
            this.data.get('result.nurseDependenceDamage') +
            this.data.get('result.nutritionDamage') +
            this.data.get('result.identifyDamage') +
            this.data.get('result.trafficDamage') +
            this.data.get('result.assistDamage') +
            this.data.get('result.propertyDamage')).toFixed(2));
        var over1= 0;
        var over2= 0;
        var over3= 0;
        var firstClass = 110000;
        var secondClass = 10000;
        var thirdClass = 2000;
        //交强险：分三类进行赔付，最多不超过122000,驾驶员无责时不超过原本的10%
        if(this.data.get('params.youDuty') == 5){
            firstClass = 11000;
            secondClass = 1000;
            thirdClass = 100;
        }
        //第一类：残疾赔偿金 + 误工费 + 护理费 + 被扶养人生活费 + 交通费 + 残疾辅助器具费 + 精神损害抚慰金，最多不超过110000
        var a =
            this.data.get('result.disabilityDamage') +
            this.data.get('result.tardyDamage') +
            this.data.get('result.nurseDamage') +
            this.data.get('result.dependentsDamage') +
            this.data.get('result.trafficDamage') +
            this.data.get('result.assistDamage') +
            this.data.get('result.moralDamage');
        if (a > firstClass) {
            over1 = a - firstClass;
            a = firstClass;
        }
        //第二类：医药费 + 住院伙食费 + 营养费，最多不超过10000
        var b =
            this.data.get('result.medicalDamage') +
            this.data.get('result.inpatientFoodDamage') +
            this.data.get('result.nutritionDamage');
        if (b > secondClass) {
            over2 = b - secondClass;
            b = secondClass;
        }
        //第三类：财产损失费，最多不超过2000
        var c = this.data.get('result.propertyDamage');
        if (c > thirdClass) {
            over3 = c - thirdClass;
            c = thirdClass;
        }
        if (this.data.get('params.insurances[0]').checked) {
            this.data.set('result.insuranceDamage1', a + b + c);
            var res = (over1 + over2 + over3 + this.data.get('result.identifyDamage')) * driverRes;
            this.data.set('result.insuranceDamage2', parseFloat(res.toFixed(2)));
        }
        else {
            this.data.set('result.insuranceDamage1', 0);
            var res = (over1 + over2 + over3 + this.data.get('result.identifyDamage')) * driverRes + a + b + c;
            this.data.set('result.insuranceDamage2', parseFloat(res.toFixed(2)));
        }
        this.data.set('result.totalDamage2',
            parseFloat(this.data.get('result.insuranceDamage1')) + parseFloat(this.data.get('result.insuranceDamage2')));
        this.data.set('result.insuranceDamage3',parseFloat(this.data.get('result.totalDamage')) - parseFloat(this.data.get('result.insuranceDamage2')) - parseFloat(this.data.get('result.insuranceDamage1')));
        this.data.set('itemNumber', 0);
        var self=this;
        var noresult = ["totalDamage","insuranceDamage1","insuranceDamage2","totalDamage2"];
        $.each(this.data.get('result'),function (item) {
            self.data.set('result.'+item,window.changeNum._formatNum(self.data.get('result.'+item)+''));
            if(parseFloat(self.data.get('result.'+item)) > 0 && noresult.indexOf(item) == -1){
                self.data.set('itemNumber', self.data.get('itemNumber')+1) ;
            }
        });
        for(var f in this.data.get('params.dependents')){
            if(f.length<=2){
                self.data.set('params.dependents['+f+'].fee',window.changeNum._formatNum(self.data.get('params.dependents['+f+'].fee') + ''));
            }
        }
        this.data.set('showFlag', 2);
        this.dispatch("goScroll",$('.count')[0].offsetTop+40);
    },
    showSelect: function() {
        this.data.set('seen', !this.data.get('seen'));
    },
    add: function(index, max, input) {
        var i = this.data.get('params.grades['+index+']');
        if (max > input) {
            this.data.set('params.grades['+index+'].number', input + 1);
            if (i.ischecked == false) {
                this.data.set('params.grades['+index+'].ischecked', true);
                this.otherGrade(index);
                this.maxLevel();
            }
        }
    },
    reduce: function(index, max, input) {
        var i = this.data.get('params.grades['+index+']');
        if (input > 0) {
            this.data.set('params.grades['+index+'].number', input - 1);
            if (this.data.get('params.grades['+index+']').number == 0) {
                this.data.set('params.grades['+index+'].ischecked', false);
                this.maxLevel();
            }
        }
    },
    addGrade: function(index) {
        var i = this.data.get('params.grades['+index+']');
        if (i.ischecked == false) {
            this.data.set('params.grades['+index+'].number', 1);
            this.data.set('params.grades['+index+'].ischecked', true);
        } else {
            this.data.set('params.grades['+index+'].number', 0);
            this.data.set('params.grades['+index+'].ischecked', false);
        }
        this.otherGrade(index);
        this.maxLevel();
    },
    otherGrade: function(index){
        var i = this.data.get('params.grades['+index+']');
        if(i.value == 11 && i.ischecked){
            for(var a in this.data.get('params.grades')){
                if(this.data.get('params.grades['+a+']').value < 11){
                    this.data.set('params.grades['+a+'].ischecked', false);
                    this.data.set('params.grades['+a+'].number', 0);
                }
            }
        }else {
            this.data.set('params.grades[0].ischecked', false);
        }
    },
    maxLevel: function() {
        this.data.set('levels', []);
        this.data.set('gradeMessage' , ["伤残等级（可多选）"]);
        var lev = this.data.get('levels');
        var ifFirst = true;
        for (var v in this.data.get('params.grades')) {
            if(v.length<=2){
                if (this.data.get('params.grades['+v+']').ischecked == true && ifFirst) {
                    this.data.set('gradeMessage' , this.data.get('params.grades['+v+']').grade);
                    lev.push(this.data.get('params.grades['+v+']').value);
                    ifFirst = false;
                } else if (this.data.get('params.grades['+v+']').ischecked == true) {
                    this.data.push('gradeMessage',this.data.get('params.grades['+v+']').grade);
                    lev.push(this.data.get('params.grades['+v+']').value);
                }
            }
        }
        if (lev.length > 0) {
            this.data.set('params.level', Math.min.apply(null, lev));
        } else {
            this.data.set('params.level', 10);
        }
    },
    createReport: function()
    {
        this.data.set('switchFlag',2);
        this.dispatch('goTo',$('.createReport')[0].offsetTop);

        //获取案例接口
        var params={
            caseType:this.data.get('caseType'),
            disabilityLevel:this.data.get('params.level')
        };
        var me=this;
        Api("post","/api/calculation/v2/getCaseList",JSON.stringify(params)).then(function(response){
            if (response) {
                me.data.set('caseList',response.caseList);
            }
        });

        var data={
            userId:localStorage.sysUserId,
            calculationType:this.data.get('businessType'),
            sourceType:2,
            sourceTerminalId:1,
            calculationParams:this.data.get('params'),
            calculationResult:this.data.get('result'),
        };
        Api("post","/api/calculation/v2/saveCalculationLog",JSON.stringify(data)).then(function(response){});
    },
    createCort: function(t){
        this.dispatch('createCort',t);
    },
    back: function(flag){
        this.data.set('switchFlag',flag);
    },
    toggle: function (e) {
        var args=e.target||e.srcElement;
        args.value==0?args.value='':args.value=args.value;
    },
    toggle2: function (e) {
        var args=e.target||e.srcElement;
        args.value==''?args.value=0:args.value=args.value;
        var num=Number(args.value);
        (isNaN(num))?args.value=0:args.value=args.value;
    },
    compare: function(prop){
        return function (obj1, obj2) {
            var val1 = obj1[prop];
            var val2 = obj2[prop];if (val1 < val2) {
                return -1;
            } else if (val1 > val2) {
                return 1;
            } else {
                return 0;
            }
        }
    },
    hide: function () {
        this.data.set('explain',0);
    },
    getExplain: function (type){
        this.data.set('explain',type);
    },
    changeHospital: function(){
        if(this.data.get("selectProv.value") == '金华市' && (this.data.get("params.accidentStartTime") == '2018' || this.data.get("params.accidentStartTime") == '2019')){
            if(this.data.get("params.hospitalCategory") == 1){
                this.data.set("params.foodFee2",30);
            }else if(this.data.get("params.hospitalCategory") == 2){
                this.data.set("params.foodFee2",50);
            }else if(this.data.get("params.hospitalCategory") == 3){
                this.data.set("params.foodFee2",100);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/trafficAccidentDisablity.js
// module id = 355
// module chunks = 1